import React from "react";

export const Contact = (props) => {
  const currentYear = new Date().getFullYear();

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="row">
            {/* Left Section */}
            <div className="col-md-6">
              <div className="section-title">
                <h2>Get In Touch</h2>
                <p>
                  You can directly reach us on WhatsApp by clicking the icon
                  below.
                </p>
              </div>

              {/* WhatsApp Icon */}
              <div style={{ marginTop: "20px" }}>
                <a
                  href="https://web.whatsapp.com/send?phone=6580345706&text=Hi%20Aerolines%20!"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Contact us on WhatsApp"
                  title="Contact us on WhatsApp"
                  style={{
                    fontSize: "60px",
                    color: "#FFD700", // Bright yellow
                    transition: "0.3s",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.color = "#25D366")
                  }
                  onMouseOut={(e) => (e.currentTarget.style.color = "#FFD700")}
                >
                  <i className="fa fa-whatsapp"></i>
                </a>
              </div>
            </div>

            {/* Right Section - Contact Info with 2 columns */}
            <div className="col-md-6 contact-info">
              <div className="row">
                {/* Column 1 */}
                <div className="col-sm-6">
                  <div className="contact-item">
                    <p>
                      <span>
                        <i className="fa fa-phone"></i> Singapore
                      </span>
                      {props.data && props.data.sgphone1 ? (
                        <a href={`tel:${props.data.sgphone1}`}>
                          {props.data.sgphone1}
                        </a>
                      ) : (
                        "loading"
                      )}
                      <br />
                      {props.data && props.data.sgphone2 ? (
                        <a href={`tel:${props.data.sgphone2}`}>
                          {props.data.sgphone2}
                        </a>
                      ) : (
                        "loading"
                      )}
                    </p>
                  </div>
                </div>

                {/* Column 2 */}
                <div className="col-sm-6">
                  <div className="contact-item">
                    <p>
                      <span>
                        <i className="fa fa-phone"></i> Malaysia
                      </span>
                      {props.data && props.data.myphone ? (
                        <a href={`tel:${props.data.myphone}`}>
                          {props.data.myphone}
                        </a>
                      ) : (
                        "loading"
                      )}
                    </p>
                  </div>
                </div>
               
              </div>

              {/* ✅ New Row for Address */}
              <div className="row" style={{ marginTop: "20px" }}>
                <div className="col-sm-6">
                  <div className="contact-item">
                    <p>
                      <span>
                        <i className="fa fa-map-marker"></i> Address
                      </span>
             
                      {props.data && props.data.address ? (
                        <>
                          {props.data.address}
                          <br />
                          Singapore 729044
                        </>
                      ) : (
                        "loading"
                      )}
                    </p>
                  </div>
                </div>
                    <div className="col-sm-6">


                  <div className="contact-item">
                    <p>
                      <span>
                        <i className="fa fa-envelope-o"></i> Email
                      </span>{" "}
                      {props.data && props.data.email ? (
                        <a href={`mailto:${props.data.email}`}>
                          {props.data.email}
                        </a>
                      ) : (
                        "loading"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Social Links */}
          <div className="row">
            <div className="col-md-12">
              <div className="social text-center">
                <ul className="list-inline">
                  <li>
                    <a href={props.data ? props.data.facebook : "/"}>
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.twitter : "/"}>
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.youtube : "/"}>
                      <i className="fa fa-youtube"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy;{currentYear} Aerolines Engineering & Construction Pte Ltd.
            All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};
